import Edit from "../../layouts/Edit";
import Input from "../form-input/Input";

const EditAddress = ({
  editFirstname,
  setEditFirstname,
  editLastname,
  setEditLastname,
  editEmail,
  setEditEmail,
  editPhonenumber,
  setEditPhonenumber,
  editAddress,
  setEditAddress,
  editState,
  setEditState,
  editCity,
  setEditCity,
  toggleBackdrop,
  handleEdit,
  loading,
}) => {
  return (
    <Edit widthXL="xl:w-addressWidth">
      <div className="flex flex-wrap justify-between">
        <div className="w-full md:w-49.5% h-addressHeight">
          <Input
            type="text"
            placeholder="First Name"
            value={editFirstname}
            onValueChange={setEditFirstname}
            required={true}
          />
        </div>
        <div className="w-full md:w-49.5% h-addressHeight">
          <Input
            type="text"
            placeholder="Last Name"
            value={editLastname}
            onValueChange={setEditLastname}
            required={true}
          />
        </div>
        <div className="w-full md:w-49.5% h-addressHeight">
          <Input
            type="email"
            placeholder="Email Address"
            value={editEmail}
            onValueChange={setEditEmail}
            required={true}
          />
        </div>
        <div className="w-full md:w-49.5% h-addressHeight">
          <Input
            type="tel"
            placeholder="Phone Number"
            value={editPhonenumber}
            onValueChange={setEditPhonenumber}
            required={true}
          />
        </div>

        <div className="w-full xl:w-full h-addressHeight border-none">
          <Input
            type="text"
            placeholder="Address"
            value={editAddress}
            onValueChange={setEditAddress}
            required={true}
          />
        </div>

        <div className="w-full md:w-49.5% h-addressHeight">
          <Input
            type="text"
            placeholder="State/Region"
            value={editState}
            onValueChange={setEditState}
            required={true}
          />
        </div>

        <div className="w-full md:w-49.5% h-addressHeight">
          <Input
            type="text"
            placeholder="City"
            value={editCity}
            onValueChange={setEditCity}
            required={true}
          />
        </div>
      </div>
      <div className="flex justify-end mt-2 gap-5 itens-center">
        <button
          className="w-24 h-10 rounded-3xl font-bold outline-none border border-black text-black"
          onClick={toggleBackdrop}
        >
          Close
        </button>
        <button
          className={`w-24 h-10 rounded-3xl font-bold outline-none 
                  bg-logoRed
                  text-white`}
          disabled={loading}
          onClick={handleEdit}
        >
          {loading ? "Saving..." : "save"}
        </button>
      </div>
    </Edit>
  );
};

export default EditAddress;
